<template>
  <div>
    <div>
      <dyhBasetable
        :who="'setVipPermission'"
        :column="underinfoColumn"
        ref="dyhBaseTableRef"
        @reflashTable="getShopList"
        @submit="submit"
        @setGrade="setGrade"
        :bs_place="'请输入会员名，会员卡号查询'"
      ></dyhBasetable>
    </div>
  </div>
</template>
<script>
// import { getOnLineMerchant, getOfflinestoresList } from "@/api/service.js";
import { bingAuditList, alterBindingStatus } from "@/api/v2/merchant.js";
import { wxUnionIdToOpenId } from "@/api/merchant.js";
import { cellStyleOption } from "@/js/sheettablecolumn.js";
import dyhBasetable from "@/components/dyh-basetable.vue";
import { offlineVipGenerate } from "@/api/offlinestores.js";
export default {
  name: "setVipPermission",
  data() {
    return {
      classify_no: "",
      //单元格样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
        ...cellStyleOption,
      },
      checkboxOption: {
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          console.log(row, isSelected, selectedRowKeys);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          console.log(isSelected, selectedRowKeys);
        },
      },
      //线下店铺信息表格的列
      underinfoColumn: [
        /* {
          field: "",
          key: "b",
          title: "",
          type: "checkbox",
          width: 50,
          align: "center",
          fixed: "left"
        }, */
        {
          field: "index",
          key: "a",
          title: "行号",
          width: 60,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.rowKey + 1;
          },
        },
        {
          field: "account_id",
          key: "account_id",
          title: "卡号",
          align: "center",
          width: 150,
        },
        {
          field: "account_name",
          key: "account_name",
          title: "用户名",
          align: "center",
          width: 150,
        },
        {
          field: "birthday",
          key: "birthday",
          title: "用户生日",
          align: "center",
          width: 250,
          fixed: "left",
          ellipsis: {
            showTitle: true,
          },
        },
        /* {
          field: "create_time",
          key: "create_time",
          title: "申请时间",
          align: "center",
          sortBy: "",
          width: 150
        }, */
        {
          field: "sex",
          key: "sex",
          title: "性别",
          align: "center",
          width: 150,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            /*             console.log(row);
            console.log(column); */
            const text = row["sex"] == "0" ? "男" : "女";
            return <span>{{ text }}</span>;
          },
        },
        {
          field: "",
          key: "e",
          title: "管理",
          width: 200,
          center: "left",
          fixed: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <button
                  class="underinfo-button-err"
                  on-click={() => this.aduitGenerate([row])}
                >
                  审核
                </button>
              </span>
            );
          },
        },
      ],

      ckeyWords: ["在线"],
      underinfo_list: [], //显示店铺
      all_underinfo_list: [], //所有店铺
      scroll_height: "", //表格高度
    };
  },
  components: { dyhBasetable },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 180;
        } else {
          this.scroll_height = newinner.innerHeight - 210;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
  },
  async mounted() {
    this.loadingInstance = this.$veLoading({
      target: "#in-sheet",
      // 等同于
      // target:"#loading-container"
      overlayBackgroundColor: "rgba(255,255,255,.5)",
      name: "grid",
    });
    this.getShopList();
  },
  methods: {
    submit() {
      this.aduitGenerate(this.underinfo_list);
    },
    setGrade(e) {
      this.classify_no = e;
    },
    editRow() {
      // console.log("this.editRow");
    },
    /**
     * 按下审核的行
     * @param {object} row 行号
     */
    async aduitGenerate(row) {
      // console.log(row);
      /* const open_data = await wxUnionIdToOpenId(row.wx_unionid);
      if (open_data.data && open_data.data.resp_data) {
        row.wx_openid = open_data.data.resp_data.open_id;
      } */
      /*  */
      /* const res = await offlineVipGenerate();
      console.log("", res);
      if (this.testR(res)) {} */
      for (let i = 0; i < row.length; i++) {
        row[i].name = row[i].account_name;
      }
      // console.log("row------------------", row);
      const result = await alterBindingStatus(row);
      console.log("审核接口返回值：", result);
      if (this.testR(result) && result.data.resp_data[0].state == "OK") {
        this.successMessage("审核成功！");
        this.getShopList(); //重新获取一下
      } else {
        this.warnMessage(result.data.resp_data[0].message);
      }
    },
    async getShopList() {
      this.underinfo_list = [];
      this.all_underinfo_list = [];
      const aduitlist = await bingAuditList();
      if (aduitlist == [] || aduitlist.length == 0) {
        this.warnMessage("没有发现待审核的会员！");
        this.$refs.dyhBaseTableRef.getShopList(this.underinfo_list);
        return;
      }
      for (let i = 0; i < aduitlist.length; i++) {
        this.underinfo_list.push({
          rowKey: i,
          ...aduitlist[i],
          expire_in: "2099-12-31",
        });
      }
      this.$refs.dyhBaseTableRef.getShopList(this.underinfo_list);
    },
  },
};
</script>

<style lang="less" scoped>
.table-header-cell-class {
  background: #409eff !important;
  color: #fff !important;
}
.underinfo-top {
  display: flex;
  justify-content: space-between;
  &-l-f {
    display: flex;
    align-items: center;
    width: calc(100% - 285px);
    height: 40px;
    scrollbar-width: none;
    padding: 0 10px 0 0;
    &-span {
      margin: 0 10px 0 0;
      color: #606266;
      cursor: pointer;
      user-select: none;
    }
    &-clicked {
      color: #409eff;
      font-weight: 700;
    }
  }
}
.underinfo {
  // padding: 10px;
  width: 100%;
  height: 100%;
}
.underinfo-btm {
  width: 100%;
  margin-top: 10px;
}
.underinfo-button-primary {
  background-color: #409eff;
  color: #fff;
}
.underinfo-button-err {
  background-color: rgb(255, 0, 0);
  min-width: 100px;
  min-height: 30px;
  color: #fff;
}
</style>
